import { render, staticRenderFns } from "./RegistrationComplete.vue?vue&type=template&id=a13b2a76&"
import script from "./RegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./RegistrationComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports